import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Helmet from 'react-helmet-async';

import ConfigStore from '../../store/ConfigStore';
import { modelOf } from '../../prop-types';
import GoogleAnalyticsGTM from '../GoogleAnalyticsGTM';
import AccountStore from '../../store/AccountStore';

@observer
class GoogleTagManager extends Component {
  componentDidMount() {
    const { accountStore, configStore } = this.props;
    if (configStore.gtm.enabled) {
      new GoogleAnalyticsGTM(accountStore);
    }
  }

  render() {
    const { configStore } = this.props;

    if (!configStore.gtm.enabled) {
      return null;
    }

    return (
      <div>
        <Helmet>
          <script>
            {`
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              originalLocation: document.location.protocol + '//' +
              document.location.hostname +
              document.location.pathname +
              document.location.search
            });
            `}
          </script>
          <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${
            configStore.gtm.containerId
          }');`}
          </script>
        </Helmet>
        <noscript>
          <iframe
            title="GTM"
            src={`https://www.googletagmanager.com/ns.html?id=${
              configStore.gtm.containerId
            }`}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
      </div>
    );
  }
}

GoogleTagManager.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired
};

export default inject('accountStore', 'configStore')(GoogleTagManager);



// WEBPACK FOOTER //
// ./src/analytics/GoogleTagManager/index.jsx